module.exports = __webpack_public_path__ + "static/media/box.138a64cb.png";